import React from 'react';
import {
    IonChip,
    IonItem,
    IonLabel,
} from '@ionic/react';
import { Proforma } from '../../../../models';
import { Ages } from '../../../../utils/ages';
import './OrderCard.css';

interface Props {
    order: Proforma;
}

export const statusColor = (status: Proforma['status']) => {
    switch (status) {
        case 'paid':      return 'success';
        case 'pending':   return 'warning';
        case 'failed':    return 'danger';
        case 'cancelled': return 'medium';
    }
};

export const statusLabel = (status: Proforma['status']) => {
    switch (status) {
        case 'paid':      return 'Paid';
        case 'pending':   return 'Pending';
        case 'failed':    return 'Failed';
        case 'cancelled': return 'Cancelled';
    }
};

const OrderCard: React.FC<Props> = ({ order }) => {
    const date = order.createdAt ? new Ages(order.createdAt).toFormat('dd mmm yyyy') : '—';

    return (
        <IonItem button detail routerLink={`/orders/${order.uuid}`} className="order-row">
            <IonLabel>
                <p className="order-row-date">{date}</p>
                <h3 className="order-row-number">{order.numberText}</h3>
            </IonLabel>
            <div className="order-row-right" slot="end">
                <p className="order-row-total">{order.totalDisplay}</p>
                <IonChip color={statusColor(order.status)} className="order-row-chip">
                    {statusLabel(order.status)}
                </IonChip>
            </div>
        </IonItem>
    );
};

export default OrderCard;
